/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * BlackChevronLeftIcon - Auto-generated from icon.js
 */
export const BlackChevronLeftIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="icon/app/chevron-left">
			<path id="Vector" d="M15 18L9 12L15 6" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</g>
	</svg>
);

export default BlackChevronLeftIcon;
